module.exports = __webpack_public_path__ + "img/7.cc2f1447.jpg";